/*
 * ClickAwayListener
 * @module components
 * @flow
 */

import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import EventListener from 'react-event-listener';
import * as R from 'ramda';

export type ClickAwayListenerProps = {
  children?: React$Node,
  onClickAway: (SyntheticEvent<HTMLDivElement>) => void,
};

export class ClickAwayListener extends Component<ClickAwayListenerProps> {
  node = null;

  static defaultProps = {
    onClickAway: () => {},
  };

  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this);
  }

  handleClickAway = (e: SyntheticEvent<HTMLDivElement>) => {
    // Ignore events that have been `event.preventDefault()` marked.
    if (!this.node) {
      return;
    }

    const { documentElement } = R.pathOr(
      document,
      ['node', 'ownerDocument'],
      this,
    );

    if (
      documentElement &&
      // $FlowIssue
      documentElement.contains(e.target) &&
      // $FlowIssue
      !this.node.contains(e.target)
    ) {
      this.props.onClickAway(e);
    }
  };

  render() {
    const { children, onClickAway, ...other } = this.props;

    return (
      <Fragment>
        {children}
        <EventListener
          target="document"
          onClick={this.handleClickAway}
          {...other}
        />
      </Fragment>
    );
  }
}
